import classNames from 'classnames';
import React from 'react';

import styles from './styles.module.scss';

export function BoulderRoutesResults({
  routeResults,
  is2NRow,
  routeNumbers,
}: {
  routeResults: ClimberRoutesResults;
  is2NRow: boolean;
  routeNumbers: number[];
}) {
  return (
    <div
      className={classNames(is2NRow && styles.alternateRow, styles.routeScores)}
    >
      {routeNumbers.map((routeNr) => (
        <RouteScoreIndicator
          key={routeNr}
          topped={!!routeResults[routeNr]?.topped}
          zoned={!!routeResults[routeNr]?.zoned}
        />
      ))}
    </div>
  );
}

export function LeadRoutesResults({
  routeResults,
  is2NRow,
  routeNumbers,
}: {
  routeResults: LeadRouteResults;
  is2NRow: boolean;
  routeNumbers: number[];
}) {
  return (
    <div
      className={classNames(is2NRow && styles.alternateRow, styles.routeScores)}
    >
      {routeNumbers.map((routeNr) => {
        const time = routeResults[routeNr]?.time || 0;
        const points = routeResults[routeNr]?.points;
        return (
          <div key={routeNr} className={styles.leadRouteResult}>
            {time > 0 && points}
          </div>
        );
      })}
    </div>
  );
}

function RouteScoreIndicator({
  topped,
  zoned,
}: {
  topped: boolean;
  zoned: boolean;
}) {
  return (
    <div className={styles.routeScoreIndicator}>
      <div
        className={classNames(
          styles.routeTopIndicator,
          topped && styles.filled,
        )}
      />
      <div
        className={classNames(
          styles.routeZoneIndicator,
          zoned && styles.filled,
        )}
      />
    </div>
  );
}
